import React from 'react';

function FooterSection() {
  const styles = {
    footer: {
      width: '100%', maxWidth: 1920, minHeight: 544, background: '#090909', opacity: 1,
      padding: '48px clamp(24px, 12.5vw, 240px) 32px', boxSizing: 'border-box',
      display: 'flex', flexDirection: 'column'
    },
    topRow: {
      display: 'flex', gap: 120, marginBottom: 48
    },
    leftCol: {
      display: 'flex', flexDirection: 'column', gap: 24
    },
    logo: {
      width: 284.2, height: 90, objectFit: 'contain', display: 'block'
    },
    companyDesc: {
      fontFamily: 'Lato', fontWeight: 400, fontSize: '20px', lineHeight: '28px',
      letterSpacing: 0, color: '#FFFFFF', margin: 0, maxWidth: 381
    },
    linksCol: {
      display: 'flex', flexDirection: 'column', gap: 20
    },
    colHeading: {
      fontFamily: 'Lato', fontWeight: 600, fontSize: '20px', lineHeight: '28px',
      letterSpacing: 0, color: '#FFFFFF', margin: '0 0 8px 0'
    },
    link: {
      fontFamily: 'Lato', fontWeight: 400, fontSize: '20px', lineHeight: '38px',
      letterSpacing: 0, color: '#FFFFFF', textDecoration: 'none'
    },
    dashLine: {
      width: '100%', maxWidth: 1440, height: 0, borderTop: '1.5px solid rgba(255, 255, 255, 0.12)',
      opacity: 1, marginBottom: 24
    },
    copyright: {
      fontFamily: 'Lato', fontWeight: 400, fontSize: '20px', lineHeight: '28px',
      letterSpacing: 0, color: '#FFFFFF', margin: 0, textAlign: 'center'
    },
    rightCols: {
      display: 'flex', gap: 48, marginLeft: 'auto'
    }
  };

  const quickLinks = [
    { label: 'Home', href: '/' },
    { label: 'About Us', href: '/about' },
    { label: 'Services', href: '/services' },
    { label: 'Projects', href: '#' },
    { label: 'Contact Us', href: '#' }
  ];
  const legalLinks = [
    { label: 'Privacy Policy', href: '#' },
    { label: 'Terms & Conditions', href: '#' },
    { label: 'Quality & Safety Policy', href: '#' }
  ];

  return React.createElement('footer', { style: styles.footer, className: 'footer-section' },
    React.createElement('div', { style: styles.topRow, className: 'footer-top-row' },
      React.createElement('div', { style: styles.leftCol },
        React.createElement('img', { src: '/SunRiseFooter.png', alt: 'Sunrise Infrabuild', style: styles.logo }),
        React.createElement('p', { style: styles.companyDesc },
          'Sunrise Infrabuild Pvt Ltd is a fast-growing construction company delivering integrated building and infrastructure solutions across India.'
        )
      ),
      React.createElement('div', { style: styles.rightCols, className: 'footer-right-cols' },
        React.createElement('div', { style: styles.linksCol },
          React.createElement('h4', { style: styles.colHeading }, 'Quick Links'),
          quickLinks.map(function (item, i) {
            return React.createElement('a', { key: i, href: item.href, style: styles.link }, item.label);
          })
        ),
        React.createElement('div', { style: styles.linksCol },
          React.createElement('h4', { style: styles.colHeading }, 'Legal & Compliance'),
          legalLinks.map(function (item, i) {
            return React.createElement('a', { key: i, href: item.href, style: styles.link }, item.label);
          })
        )
      )
    ),
    React.createElement('div', { style: { display: 'flex', flexDirection: 'column', alignItems: 'center' } },
      React.createElement('div', { style: styles.dashLine }),
      React.createElement('p', { style: styles.copyright }, '© 2025 Sunrise Infrabuild Pvt Ltd. All Rights Reserved.')
    )
  );
}

export default FooterSection;
